import type { AlphaSafeZone } from "@nlc/shared-types";

import { Switch } from "@/components/switch";

export function SafeZoneToggle({
  isSelected,
  onChange,
}: {
  isSelected: boolean;
  onChange: (isSelected: boolean) => void;
}) {
  return (
    <Switch
      className="rounded-lg border border-border-secondary bg-bg-primary px-lg py-md font-semibold text-text-primary"
      isSelected={isSelected}
      labelPosition="left"
      onChange={onChange}
    >
      Safe zones
    </Switch>
  );
}

export function SafeZoneOverlay({ safeZone }: { safeZone: AlphaSafeZone }) {
  const { bottomPct, leftPct, rightPct, topPct } = safeZone;

  return (
    <div aria-hidden className="pointer-events-none absolute inset-0">
      <div
        className="absolute inset-0 bg-bg-error-solid/25"
        style={{
          clipPath: `polygon(evenodd, 0 0, 100% 0, 100% 100%, 0 100%, 0 0, ${leftPct}% ${topPct}%, ${100 - rightPct}% ${topPct}%, ${100 - rightPct}% ${100 - bottomPct}%, ${leftPct}% ${100 - bottomPct}%, ${leftPct}% ${topPct}%)`,
        }}
      />
      <div
        className="absolute border border-dashed border-error-solid"
        style={{
          bottom: `${bottomPct}%`,
          left: `${leftPct}%`,
          right: `${rightPct}%`,
          top: `${topPct}%`,
        }}
      />
      <MarginLabel edge="top" pct={topPct} />
      <MarginLabel edge="bottom" pct={bottomPct} />
    </div>
  );
}

function MarginLabel({ edge, pct }: { edge: "bottom" | "top"; pct: number }) {
  if (pct === 0) return null;

  return (
    <span
      className={`absolute left-1/2 -translate-x-1/2 rounded-full bg-bg-primary px-sm py-xxs text-xs font-semibold text-text-error-primary ${edge === "top" ? "-translate-y-1/2" : "translate-y-1/2"}`}
      style={{ [edge]: `${pct / 2}%` }}
    >
      {Math.round(pct)}% margin
    </span>
  );
}
